import Axios from 'axios';
import { hmac } from './hmac.js';
import { get } from './get.js';

const DEFAULT_LOCAL_STORAGE_LANG_KEY = '_lang';
const _getBeforeRequestHandler = ({ localStorageLangKey = DEFAULT_LOCAL_STORAGE_LANG_KEY }) => (config) => {
    if (config.url?.includes('undefined')) {
        throw new Error('URL contains undefined');
    }
    else {
        const _language = localStorage.getItem(localStorageLangKey) || 'zh';
        Object.assign(config.headers || {}, { lang: _language });
        return config;
    }
};
function _responseHandler(response) {
    const data = get(response, 'data.data', response.data);
    return { ...response, data };
}
const TIMEOUT = 600000;
// eslint-disable-next-line react-func/max-lines-per-function
const createClientAxiosInstance = ({ baseUrl, 
// 网关相关
envGateWayBaseUrl, secret, username, apiKey, 
// interceptors 外部传入
beforeRequestHandler, responseHandler = _responseHandler, errorHandler, extraConfig = {}, }) => {
    const { localStorageLangKey = DEFAULT_LOCAL_STORAGE_LANG_KEY } = extraConfig;
    const GATEWAY_BASE_URL = envGateWayBaseUrl ? `${envGateWayBaseUrl}${baseUrl}` : baseUrl;
    const _beforeRequestHandler = beforeRequestHandler
        ? beforeRequestHandler
        : _getBeforeRequestHandler({
            localStorageLangKey,
        });
    const GateWayInstance = Axios.create({
        baseURL: GATEWAY_BASE_URL,
        timeout: TIMEOUT,
    });
    const DirectInstance = Axios.create({
        baseURL: baseUrl,
        timeout: TIMEOUT,
    });
    GateWayInstance.interceptors.request.use(config => {
        if (envGateWayBaseUrl && secret && username && apiKey) {
            Object.assign(config.headers || {}, hmac(config, {
                secret: secret,
                username: username,
                apiKey: apiKey,
            }));
        }
        return _beforeRequestHandler(config);
    });
    GateWayInstance.interceptors.request.use(_beforeRequestHandler);
    GateWayInstance.interceptors.response.use(responseHandler, errorHandler);
    DirectInstance.interceptors.request.use(_beforeRequestHandler);
    DirectInstance.interceptors.response.use(responseHandler, errorHandler);
    return {
        GateWayInstance,
        DirectInstance,
    };
};

export { createClientAxiosInstance };
